import React from 'react';
import cls from 'classnames';
interface ISKBreadcrumbsLink {
  label: string;
  slug: string;
}
export interface ISKBreadcrumbs {
  links: ISKBreadcrumbsLink[];
  className?: string;
}

export const SKBreadcrumbs: React.FC<ISKBreadcrumbs> = ({ links, className }) => {
  return (
    <ul className={cls('flex text-sm', { className: className })}>
      {links.map((link, index) => {
        return (
          <li
            className={cls('pr-1.75', {
              'font-semibold': index === links.length - 1,
              'pl-1.75': index !== 0,
              'relative breadcrumb-item--with-spacer': index !== links.length - 1,
            })}
            key={link.label}
          >
            {index < links.length - 1 && (
              <a href={link.slug} className="cursor-pointer">
                {link.label}
              </a>
            )}
            {index === links.length - 1 && <span>{link.label}</span>}
          </li>
        );
      })}
    </ul>
  );
};
